// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'clipboard-pencil';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='m16.973 11.153-5.723 5.722-2.813.563L9 14.625l5.723-5.722a1.586 1.586 0 0 1 2.243 0l.007.006a1.586 1.586 0 0 1 0 2.244zM3.937 7.883h6.75m-6.75 2.812h4.5m-4.5 2.813h2.25m0 3.93h-4.5a1.125 1.125 0 0 1-1.125-1.125V4.5a1.125 1.125 0 0 1 1.125-1.125H4.5a2.812 2.812 0 1 1 5.625 0h2.813A1.125 1.125 0 0 1 14.062 4.5v1.688' />
    <path d='M7.312 3.383a.281.281 0 0 1 0-.563m0 .563a.281.281 0 0 0 0-.563' />
  </g>
);

export const viewBox = '0 0 18 18';
